import React from 'react'
import {Registros} from '../../layouts/Registros/Registros'

export function PageRegistros() {
  return (
    <Registros></Registros>
  )
}
